module.exports = __webpack_public_path__ + "static/online-shop-3-b8b23dee4ac21dc458ebecf3c58ff9a9.png";